import LayoutCenteredMessage from 'approot/shared/layout/layout-centered-message';
import { PStyled } from 'approot/shared/styles/typography.style';
import ImageContentMailbox from 'approot/shared/images/content/image-content-mailbox';

const AssignModalNoPages = () => (
  <LayoutCenteredMessage
    headingText="No Assignable Content"
    image={<ImageContentMailbox width={120} height={120} />}
  >
    <PStyled>
      This content isn’t assignable to students. You can explore other lessons
      or resources to find student-ready material.
    </PStyled>
  </LayoutCenteredMessage>
);

export default AssignModalNoPages;
